import { render } from "./VisualizarAdjuntoComponent.vue?vue&type=template&id=6b0e5894"
import script from "./VisualizarAdjuntoComponent.vue?vue&type=script&lang=js"
export * from "./VisualizarAdjuntoComponent.vue?vue&type=script&lang=js"

import "./VisualizarAdjuntoComponent.vue?vue&type=style&index=0&id=6b0e5894&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__